import React from "react";
import environment from "src/utils/environment";

import BabyCameraNotAvailable from "./BabyCameraNotAvailable";
import BabyStoppedSeeMe from "./BabyStoppedSeeMe";
import BabyStopped from "./BabyStoppedDialog";
import ConnectionFailure from "./ConnectionFailureDialog";
import GenericFailure from "src/components/GenericFailureDialog";
import LocalCameraNotAvailable from "./LocalCameraNotAvailable";
import PlayCommandFailure from "./PlayCommandFailure";
import SeeMeAlreadyRunning from "./SeeMeAlreadyRunning";
import SeeMeStartFailure from "./SeeMeStartFailure";
import VideoModeStartFailure from "./VideoModeStartFailure";
import MultiConnectionFailure from "./MultiConnectionFailure";
import StopMonitoringAllStations from "./StopMonitoringAllStations";

export const AlertsById = {
  BABY_CAMERA_NOT_AVAILABLE: "BABY_CAMERA_NOT_AVAILABLE",
  BABY_STOPPED: "BABY_STOPPED",
  BABY_STOPPED_SEE_ME: "BABY_STOPPED_SEE_ME",
  CONNECTION_FAILURE: "CONNECTION_FAILURE",
  GENERIC_FAILURE: "GENERIC_FAILURE",
  LOCAL_CAMERA_NOT_AVAILABLE: "LOCAL_CAMERA_NOT_AVAILABLE",
  NO_FREE_TIME: "NO_FREE_TIME",
  PLAY_COMMAND_FAILURE: "PLAY_COMMAND_FAILURE",
  SEE_ME_ALREADY_RUNNING: "SEE_ME_ALREADY_RUNNING",
  SEE_ME_START_FAILURE: "SEE_ME_START_FAILURE",
  VIDEO_MODE_START_FAILURE: "VIDEO_MODE_START_FAILURE",
  MULTI_CONNECTION_FAILURE: "MULTI_CONNECTION_FAILURE",
  STOP_MONITORING_ALL_STATIONS: "STOP_MONITORING_ALL_STATIONS",
  STOP_REASON_SCHEDULER_STOP: "STOP_REASON_SCHEDULER_STOP"
};

export default function Alert({ id, props }) {
  if (!id) return null;
  return (
    <>
      <BabyCameraNotAvailable
        isOpen={id === AlertsById.BABY_CAMERA_NOT_AVAILABLE}
        {...props}
      />
      <BabyStopped
        isOpen={
          id === AlertsById.BABY_STOPPED ||
          id === AlertsById.STOP_REASON_SCHEDULER_STOP
        }
        stoppedByButton={id === AlertsById.BABY_STOPPED}
        {...props}
      />
      <BabyStoppedSeeMe
        isOpen={id === AlertsById.BABY_STOPPED_SEE_ME}
        {...props}
      />
      <ConnectionFailure
        isOpen={id === AlertsById.CONNECTION_FAILURE}
        {...props}
      />
      <GenericFailure isOpen={id === AlertsById.GENERIC_FAILURE} {...props} />
      <LocalCameraNotAvailable
        isOpen={id === AlertsById.LOCAL_CAMERA_NOT_AVAILABLE}
        {...props}
      />
      <PlayCommandFailure
        isOpen={id === AlertsById.PLAY_COMMAND_FAILURE}
        {...props}
      />
      <SeeMeStartFailure
        isOpen={id === AlertsById.SEE_ME_START_FAILURE}
        {...props}
      />
      <SeeMeAlreadyRunning
        isOpen={id === AlertsById.SEE_ME_ALREADY_RUNNING}
        {...props}
      />
      <VideoModeStartFailure
        isOpen={id === AlertsById.VIDEO_MODE_START_FAILURE}
        {...props}
      />
      {environment.supportsMultibaby && (
        <MultiConnectionFailure
          isOpen={id === AlertsById.MULTI_CONNECTION_FAILURE}
          {...props}
        />
      )}
      {environment.supportsMultibaby && (
        <StopMonitoringAllStations
          isOpen={id === AlertsById.STOP_MONITORING_ALL_STATIONS}
          {...props}
        />
      )}
    </>
  );
}
